import { Injectable, inject } from '@angular/core';

import { LocalStorageService } from '@core/common-legacy';
import { RequisitionsGroupKind } from '@core/requisitions-types';

import type { CachedRequisitionListViewState } from '../requisitions.types';
import { RequisitionsListViewType } from '../requisitions.types';

@Injectable()
export class RequisitionsListCacheService {
  private readonly localStorageService = inject(LocalStorageService);

  private readonly localStorageKey = 'requisitions-list-view-state';

  public saveDataInLocalStorage(viewState: Partial<CachedRequisitionListViewState>): void {
    this.localStorageService.set(this.localStorageKey, <CachedRequisitionListViewState>{
      ...this.getLocalStorageData(),
      ...viewState,
    });
  }

  public getLocalStorageData(): CachedRequisitionListViewState {
    return this.localStorageService.get(this.localStorageKey, {
      viewType: RequisitionsListViewType.Tiles,
      collapsedGroups: [],
      groupBy: RequisitionsGroupKind.Status,
    });
  }
}
